import React from 'react';
import { Radar } from 'react-chartjs-2';
import { Chart as ChartJS, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from 'chart.js';

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

function RadarChart({ categories }) {

  const data = {
    labels: categories.map(c => c.category?.name || c.name || 'N/A'),
    datasets: [
      {
        label: 'Nivel de Madurez',
        data: categories.map(c => c.average || c.score || 0),
        backgroundColor: 'rgba(255, 99, 132, 0.2)', // Rojo transparente
        borderColor: 'rgba(255, 99, 132, 1)',      // Borde rojo
        borderWidth: 2,
        pointBackgroundColor: 'rgba(255, 99, 132, 1)',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      r: { // ESTA ES LA 'r' QUE SOLO DEBE ESTAR AQUÍ
        angleLines: { color: '#ccc' },
        grid: { color: '#e0e0e0' },
        pointLabels: {
          color: '#0056b3', // Azul para los nombres
          font: { size: 11, weight: 'bold' }
        },
        ticks: {
          display: false, 
          max: 5,
          stepSize: 1
        },
        suggestedMin: 0,
        suggestedMax: 5
      }
    },
    plugins: {
      legend: { display: false } 
    }
  };

  return <Radar data={data} options={options} />;
}

export default RadarChart;